export function initKlaviyo() {
  if (!window.klaviyo) {
    const script = document.createElement('script');
    script.src = `https://static.klaviyo.com/onsite/js/${process.env.MIX_KLAVIYO_SCRIPT_ID}/klaviyo.js`;
    script.type = 'text/javascript';
    script.async = '';
    document.head.appendChild(script);

    script.onload = () => {
      setTimeout(() => {
        if (window.klaviyo && typeof window.klaviyo.identify === 'function') {
          window.klaviyo.identify({
            email: window.authEmail,
          });
        }
      }, 1000);
    };
  }
}
